module.exports = __webpack_public_path__ + "assets/img/cpp_test_l3.97840e3c.png";